/**
 * camelize
 * @description 文字列をキャメルケースに変換
 * @param {string} str 元の文字列
 * @param {boolean} upper アッパーキャメルケースにするか否か
 * @returns {string} キャメルケース化された文字列
 */
function camelize(str: string, upper: boolean = false): string | boolean {
  if (typeof str !== 'string') {
    throw new TypeError(`${str}は文字列ではありません。`);
  }

  return str
    .replace(/[\s-_]([a-z])/g, (match) => match.toUpperCase())
    .replace(/[\s-_]/g, '')
    .replace(/^([A-Z])/i, (match) => {
      if (upper) {
        return match.toUpperCase();
      }
      return match.toLowerCase();
    });
}

/**
 * hyphenize
 * @description 文字列をハイフンケースに変換
 * @param {string} str 元の文字列
 * @returns {string} ハイフンケース化された文字列
 */
function hyphenize(str: string): string | boolean {
  if (typeof str !== 'string') {
    throw new TypeError(`${str}は文字列ではありません。`);
  }

  return str
    .replace(/_/g, '-')
    .replace(/[A-Z]/g, (match) => `-${match}`.toLowerCase())
    .replace(/^-/, '');
}

/**
 * ucfirst
 * @description 文字列の先頭の文字を大文字に変換
 * @param {string} str 元の文字列
 * @returns {string} 先頭の文字が大文字に変換された文字列
 */
function ucfirst(str: string): string | boolean {
  if (typeof str !== 'string') {
    throw new TypeError(`${str}は文字列ではありません。`);
  }

  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
}

/**
 * lcfirst
 * @description 文字列の先頭の文字を小文字に変換
 * @param {string} str 元の文字列
 * @returns {string} 先頭の文字が小文字に変換された文字列
 */
function lcfirst(str: string): string | boolean {
  if (typeof str !== 'string') {
    throw new TypeError(`${str}は文字列ではありません。`);
  }

  return `${str.charAt(0).toLowerCase()}${str.slice(1)}`;
}

export { camelize, hyphenize, ucfirst, lcfirst };
